import React ,{useCallback,useState} from 'react';
import LoanRibbenBox from '../component/LoanRibbenBox';
import LeadDetailTabs from '../component/LoanFiledTabs';
import FullPageLoader from '../common/FullPageLoader';
import { APP_COUNTRY, COUNTRY_CODE } from '../config/constant';

interface LeadDetailProps {
  // Define any expected props here
  // example: someId?: string;
}

const LeadDetail: React.FC<LeadDetailProps> = (props) => {
  const [callReloadApi, setCallReloadApi] = useState(0);
  const [isReferralButtonDisabled, setIsReferralButtonDisabled] = useState(true);
  const [isLeadFromAgency, setLeadFromAgency] = useState(false);
  const [phLoaderCount, setPhLoaderCount] = useState(0);
  const isPhFlow = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH;

  const setLeadDetailLoading = useCallback((isLoading: boolean) => {
    setPhLoaderCount((currentCount) => {
      if (isLoading) return currentCount + 1;
      return Math.max(currentCount - 1, 0);
    });
  }, []);

  return (
    <div className="container-fluid main-outer">
      {isPhFlow && <FullPageLoader show={phLoaderCount > 0} className="lead-detail-loader-light" />}
      <div className="row">
        <LoanRibbenBox  setCallReloadApi= {setCallReloadApi} callReloadApi= {callReloadApi} isReferralButtonDisabled={isReferralButtonDisabled} isLeadFromAgency={isLeadFromAgency} setLeadDetailLoading={isPhFlow ? setLeadDetailLoading : undefined}/>
        <LeadDetailTabs callReloadApi = {callReloadApi}  setCallReloadApi = {setCallReloadApi} setIsReferralButtonDisabled={setIsReferralButtonDisabled} setLeadFromAgency={setLeadFromAgency} setLeadDetailLoading={isPhFlow ? setLeadDetailLoading : undefined}/>
      </div>
    </div>
  );
};

export default LeadDetail;
